import API_BASE_URL from '../Config';

export const getPlanCuentasPaginados = async (token, page = 0, size = 10, search = '') => {
    const url = new URL(`${API_BASE_URL}/plan-cuentas/page`);
    url.searchParams.append('page', page);
    url.searchParams.append('size', size);
    if (search) url.searchParams.append('search', search);

    const response = await fetch(url.toString(), {
        headers: { 'Authorization': `Bearer ${token}` }
    });
    if (!response.ok) throw new Error('Error al cargar plan de cuentas paginado');
    return response.json();
};

export const getPlanCuentaById = async (token, id) => {
    const response = await fetch(`${API_BASE_URL}/plan-cuentas/${id}`, {
        headers: { 'Authorization': `Bearer ${token}` }
    });
    if (!response.ok) throw new Error('Error al cargar la cuenta contable');
    return response.json();
};

export const getPlanCuentas = async (token) => {
    const response = await fetch(`${API_BASE_URL}/plan-cuentas`, {
        headers: { 'Authorization': `Bearer ${token}` }
    });
    if (!response.ok) throw new Error('Error al listar plan de cuentas');
    return response.json();
};
